import { dailySessionNotes } from '../actions/constant';
import { CancelToken } from 'axios';
const {
  GET_PATIENT_DAILY_SESSION_REQUEST,
  GET_PATIENT_INFO_DAILY_SESSION_REQUEST,
  GET_DAILY_SESSION_NOTES_REQUEST,
  UPDATE_DAILY_SESSION_NOTES_REQUEST,
  RESET_UPDATE_DAILY_SESSION_NOTES,
  REQUEST_GET_NOTE_TEMPLATE,
  REQUEST_UPDATE_NOTE,
  RESET_UPDATE_NOTE,
  REQUEST_SUBMIT_E_SIGN,
  RESET_SUBMIT_E_SIGN,
  GET_DAILY_SESSION_NOTES_RESET,
  GET_OTHER_PATIENT_DAILY_SESSION_REQUEST,
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST,
  RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION,
  RESET_OTHER_PATIENT_DAILY_SESSION,
  RESET_PATIENT_DAILY_SESSION,
  RESET_GET_NOTE_TEMPLATE,
} = dailySessionNotes;

export const getDailySessionPatientList = (payload: any, source: CancelToken) => {
  return {
    type: GET_PATIENT_DAILY_SESSION_REQUEST,
    payload,
    source,
  };
};

export const updateDailySessionSoapNotes = (payload: any) => {
  return {
    type: PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST,
    payload,
  };
};

export const resetDailySessionPatientList = () => {
  return {
    type: RESET_PATIENT_DAILY_SESSION,
  };
};

export const resetDailySessionOtherPatientList = () => {
  return {
    type: RESET_OTHER_PATIENT_DAILY_SESSION,
  };
};

export const resetDailySessionSoapNotes = () => {
  return {
    type: RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION,
  };
};

export const getDailySessionOtherPatientList = (payload: any, source: CancelToken) => {
  return {
    type: GET_OTHER_PATIENT_DAILY_SESSION_REQUEST,
    payload,
    source,
  };
};

export const getDailySessionPatientInfo = (payload: any) => {
  return {
    type: GET_PATIENT_INFO_DAILY_SESSION_REQUEST,
    payload,
  };
};

export const getDailySessionNotes = (payload: any, source: CancelToken) => {
  return {
    type: GET_DAILY_SESSION_NOTES_REQUEST,
    payload,
    source,
  };
};

export const updateDailySessionNotes = (payload: any) => {
  return {
    type: UPDATE_DAILY_SESSION_NOTES_REQUEST,
    payload,
  };
};
export const resetDailySessionNotes = () => {
  return {
    type: RESET_UPDATE_DAILY_SESSION_NOTES,
  };
};

export const getNoteTemplateAction = (uuid: string) => {
  return {
    type: REQUEST_GET_NOTE_TEMPLATE,
    uuid,
  };
};

export const resetGetNoteTemplate = () => {
  return {
    type: RESET_GET_NOTE_TEMPLATE,
  };
};

export const updateNoteActionJotform = (payload: object, uuid: string) => {
  return {
    type: REQUEST_UPDATE_NOTE,
    payload,
    uuid,
  };
};

export const resetUpdateNoteAction = () => {
  return {
    type: RESET_UPDATE_NOTE,
  };
};

export const submitEsignAction = (payload: object) => {
  return {
    type: REQUEST_SUBMIT_E_SIGN,
    payload,
  };
};

export const resetEsignAction = () => {
  return {
    type: RESET_SUBMIT_E_SIGN,
  };
};

export const resetDailyNotes = () => {
  return {
    type: GET_DAILY_SESSION_NOTES_RESET,
  };
};
